enum Types {
  AUTHENTICATE_REQUEST = 'AUTHENTICATE_REQUEST',
  AUTHENTICATE_FULFILLED = 'AUTHENTICATE_FULFILLED',
  AUTHENTICATE_REJECTED = 'AUTHENTICATE_REJECTED',
  AUTHENTICATE_LOGOUT = 'AUTHENTICATE_LOGOUT',
  AUTHENTICATE_INVALIDATE_SESSION = 'AUTHENTICATE_INVALIDATE_SESSION',

  MFA_CHANGE_REGION_FULFILLED = 'MFA_CHANGE_REGION_FULFILLED',

  AUTH_CHECK_RESTRICTIONS_REQUEST = 'AUTH_CHECK_RESTRICTIONS_REQUEST',
  AUTH_CHECK_RESTRICTIONS_FULFILLED = 'AUTH_CHECK_RESTRICTIONS_FULFILLED',
  AUTH_CHECK_RESTRICTIONS_REJECTED = 'AUTH_CHECK_RESTRICTIONS_REJECTED',

  AUTHENTICATE_MFA_REQUEST = 'AUTHENTICATE_MFA_REQUEST',
  AUTHENTICATE_MFA_FULFILLED = 'AUTHENTICATE_MFA_FULFILLED',
  AUTHENTICATE_MFA_REJECTED = 'AUTHENTICATE_MFA_REJECTED',

  SELECT_COMPANY = 'SELECT_COMPANY',
  SELECT_PARTNER = 'SELECT_PARTNER',

  FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_FULFILLED = 'FORGOT_PASSWORD_FULFILLED',
  FORGOT_PASSWORD_REJECTED = 'FORGOT_PASSWORD_REJECTED',

  REGISTER_PASSWORD_REQUEST = 'REGISTER_PASSWORD_REQUEST',
  REGISTER_PASSWORD_FULFILLED = 'REGISTER_PASSWORD_FULFILLED',
  REGISTER_PASSWORD_REJECTED = 'REGISTER_PASSWORD_REJECTED',

  TRUSTED_LOGIN_REQUEST = 'TRUSTED_LOGIN_REQUEST',
  TRUSTED_LOGIN_FULFILLED = 'TRUSTED_LOGIN_FULFILLED',
  TRUSTED_LOGIN_REJECTED = 'TRUSTED_LOGIN_REJECTED',
}

export default Types;
